import React from "react";
import { Select, Input } from "material-ui";
import { WrappedFieldProps } from "redux-form";
import LensIcon from "material-ui-icons/Lens";
import { Common } from "./Common";
import { CustomLabelStyles } from "./ExtendedField";

interface SelectOption {
    label: string;
    value: string | number;
    header?: boolean;
}

interface ExtraProps {
    renderEmptyCellItem: boolean;
}

interface ExtendedFieldProps {
    options?: SelectOption[];
    labelcase?: "lower" | "upper";
    labelStyles?: CustomLabelStyles;
    customSelectClasses?: string;
}

const renderSelectField = (
    props: Common & WrappedFieldProps & ExtendedFieldProps & ExtraProps
) => {
    const {
        input,
        meta,
        style,
        options,
        labelcase,
        label,
        renderEmptyCellItem = true,
        ...nonprops
    } = props;

    const errorClass = meta.touched && meta.error ? " error" : "";
    let t = style || {};

    const styles = {
        ...t,
        fontSize: "1.35em",
    };

    const selectDefaultClasses =
        "hypoblue hypoblue-inkbar hypoblue-underline hyposelect";
    const selectClasses = props.customSelectClasses
        ? selectDefaultClasses.concat(` ${props.customSelectClasses}`)
        : selectDefaultClasses;

    let optionCells: JSX.Element[] = [];
    renderEmptyCellItem &&
        optionCells.push(
            <option key={""} value={""}>
                {""}
            </option>
        );
    options &&
        options.forEach((element) => {
            const dis = element.header ? true : false;
            const sty = element.header ? "strongBlack" : "";
            const casedLabedl =
                labelcase === undefined
                    ? element.label
                    : labelcase === "upper"
                    ? element.label.toUpperCase()
                    : element.label.toLowerCase();

            const cell = (
                <option
                    className={sty}
                    disabled={dis}
                    key={element.value}
                    value={element.value}
                >
                    {casedLabedl}
                </option>
            );

            optionCells.push(cell);
        });

    return (
        <div>
            <label>
                <Select
                    native
                    {...nonprops}
                    {...input}
                    input={
                        <Input
                            inputProps={props}
                            classes={{
                                error: "hypo-error",
                                focused: "hypoblue",
                                disabled: "hypo-disabled",
                                root: "hypoblue",
                                underline: "hypoblue-underline",
                                input: "hypoblue",
                            }}
                        />
                    }
                    style={styles}
                    fullWidth={true}
                    error={meta.touched && !!meta.error}
                    classes={{
                        root: "hypoblue",
                        select: "hypoblue-inkbar",
                        selectMenu: "hypoblue-underline",
                        disabled: "hypoblue",
                    }}
                    className="hypoblue hypoblue-inkbar hypoblue-underline hyposelect"
                >
                    {optionCells}
                </Select>
                {label}
                {props.required && (
                    <span>
                        <LensIcon className={"hypo-lens-icon" + errorClass} />{" "}
                        <br />
                        <span style={{ color: "red" }} tabIndex={0}>
                            {meta.touched && meta.error}
                        </span>
                    </span>
                )}
            </label>
        </div>
    );
};

export default renderSelectField;



// WEBPACK FOOTER //
// ./src/components/form/RenderSelectField.tsx